import React from 'react';
import Login from './Login';

const AuthWrapper: React.FC = () => {
  return <Login />;
};

export default AuthWrapper;